<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>
    </div>
    <div>
      <loading
        :active.sync="loadingValidacionExistePTI"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="subtitulos-interno">
          <b-row>
            <b-col class="seccionTituloSubTitulo">
              <span>{{ titulo }}</span>
            </b-col>
            <b-col class="seccionCodigoSubTitulo">
              <div>{{ codigo }}</div>
            </b-col>
          </b-row>
        </div>
        <!--<md-toolbar class="subtitulos">
          <h3>{{ subtitulo }}</h3>
        </md-toolbar>-->
      </div>
    </div>
    <!-- ------------------------------ -->
    <!--<div class="row"><br /><br /></div>-->

    <!-- ------------------------------ -->
    <!-- ------------------------------ -->
    <b-tabs content-class="mt-3">
      <b-tab :title="subtitulo" active>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(guardarFormulario)">
            <!-- ------------------------------ -->
            <div class="row" v-if="mostrarFormulario">
              <br /><br />

              <div class="col-md-4">
                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-12" align="left">
                      <validation-provider
                        name="ReqTipoTag"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita">Flujo PX</label>
                        <b-form-select
                          class="parrafos"
                          size="sm parrafos"
                          v-model="idTipoTag"
                          :disabled="bloquearformularioTag"
                        >
                          <b-form-select-option
                            v-for="tipoTag in tipoTagDatosArray"
                            :key="tipoTag.idTipoTag"
                            :value="tipoTag.idTipoTag"
                            >{{ tipoTag.descripcion }}
                          </b-form-select-option>
                        </b-form-select>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12" align="left">
                      <validation-provider
                        name="ReqMotivoTag"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita">Motivo Cita</label>
                        <b-form-select
                          class="parrafos"
                          size="sm parrafos"
                          v-model="idTagMotivoCita"
                          :disabled="bloquearformularioTag"
                        >
                          <b-form-select-option
                            v-for="elem in tagmotivocitaDatosArray"
                            :key="elem.idTagMotivoCita"
                            :value="elem.idTagMotivoCita"
                            >{{ elem.descripcionTagMotivoCita }}
                          </b-form-select-option>
                        </b-form-select>
                        <p>{{ descripcionTagMotivoCitaOriginal }}</p>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-12" align="left">
                      <br />
                      <b-form-checkbox
                        id="checkbox-1"
                        v-model="esCorrectoMotivoCita"
                        name="checkbox-1"
                        :value="Boolean(true)"
                        :unchecked-value="Boolean(false)"
                        @change="
                          mostrarOcultarformularioTag(esCorrectoMotivoCita)
                        "
                        v-if="seSeleccionoMotivoTagEnSesion == true"
                      >
                        ¿El Flujo PX y motivo seleccionado en la sesión es
                        correcto?
                      </b-form-checkbox>
                      <br />
                      <b-button
                        variant="info"
                        @click="tagSeleccionadoEnLaCita"
                        v-if="seSeleccionoMotivoTagEnSesion == true"
                        >Regresar al motivo cita registrado en la
                        sesión</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br /><br /><br />
            <!-- ------------------------------ -->
            <div class="row" v-if="mostrarFormulario">
              <div class="col-4">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12" align="left">
                      <validation-provider
                        name="ReqFechaSol"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita"
                          >Fecha de la solicitud</label
                        >
                        <b-input
                          type="search"
                          v-model="tiempo"
                          :disabled="true"
                          size="sm"
                        >
                        </b-input>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12" align="left">
                      <validation-provider
                        name="ReqClinica"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita">Clínica</label>
                        <b-input v-model="nombreClinica" :disabled="true">
                        </b-input>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12" align="left">
                      <validation-provider
                        name="ReqOg"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita">Og</label>
                        <br />
                        <v-select
                          :options="doctores"
                          v-model="idEmpleado"
                          disabled
                          placeholder="Nombre del Og"
                          :reduce="
                            (nombreEmpleado) => nombreEmpleado.idEmpleado
                          "
                          label="nombreEmpleado"
                        >
                        </v-select>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-8" align="left">
                      <validation-provider
                        name="ReqEnfermedad"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <label class="letraEstiloNegrita"
                          >Enfermedad sistémica</label
                        >
                        <b-input
                          v-model="enfermedadSistemica"
                          placeholder="Introduzca enfermedad sistémica"
                          @keypress="allLetter($event)"
                        >
                          ></b-input
                        ><validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                    </div>


                  </div>
                  <div class="row">
                    <div class="col-12">
                      <validation-provider
                        name="ReqObservaciones"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <br />
                        <span class="input-group-text">
                          <span class="letraEstiloNegrita">
                            Información relevante sobre tu paciente
                            (medicamentos,tratamientos realizados
                            recientemente)</span
                          >
                        </span>
                        <textarea
                          class="form-control"
                          aria-label="With textarea"
                          v-model="observaciones"
                        ></textarea>
                        <validacion
                          :texto="
                            validationContext.errors[0]
                              ? validationContext.errors[0]
                              : ' '
                          "
                        />
                      </validation-provider>
                      <br />
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row"></div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="container-fluid"
                  v-if="pacienteTomaHerramientas.mostrarTomaHerramientas"
                >
                  <br />
                  <b-row>
                    <b-col cols="2">
                      <br />
                      <b-form-checkbox
                        class="letraEstiloNegrita"
                        v-model="
                          pacienteTomaHerramientas.sesionTomaHerramientas
                        "
                        name="check-button"
                        switch
                        >Toma herramientas
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      cols="8"
                      v-if="pacienteTomaHerramientas.sesionTomaHerramientas"
                    >
                      <b-form-group
                        label="Paquete inicial de la toma de herramientas"
                        v-slot="{ ariaTomaHerramientas }"
                      >
                        <b-form-radio-group
                          v-model="pacienteTomaHerramientas.idKit"
                          :aria-describedby="ariaTomaHerramientas"
                          name="radio-options"
                        >
                          <b-form-radio
                            :value="kit.idKit"
                            v-for="kit in pacienteTomaHerramientas.kitsInicio"
                            v-bind:key="kit.idKit"
                            >{{ kit.nombre }}</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <div v-else>
              <br /><br /><br />
              <h3 v-if="idSesionSeleccionada == null">
                <RedireccionarAgenda />
              </h3>
              <h3 v-if="!loadingValidacionExistePTI">
                <p v-if="!noTienePti">
                  El paciente ya cuenta con una solicitud de Hdx.
                </p>
              </h3>
            </div>

            <!-- ------------------------------ -->

            <!-- //idDenticion -> 1	INFANTIL, 2	ADULTO, 3	MIXTO -->
            <br />
            <br /><br />
            <br />
            <div class="row" v-if="mostrarFormulario">
              <div class="col-md-6">

                  <md-toolbar class="subtitulos">
                    <h3>Diagnóstico Adicional</h3>
                  </md-toolbar>
                  <br />
                  <div
                    class="row"
                    v-for="data of arrayAdicional"
                    v-bind:key="data.id"
                  >
                    <div class="col-5" align="left">{{ data.titulo }}.</div>
                    <div class="col-7" align="right">
                      <b-form-radio-group
                        :id="data.id"
                        v-model="data.value"
                        :options="data.elementos"
                        :name="'radio-options-apinamiento' + data.id"
                      ></b-form-radio-group>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <br />
                    <b-button
                      @click="
                        limpiarCamposExtrasPeriodontitis(
                          'adicional'
                        )
                      "
                      size="sm"
                      variant="outline-primary"
                      >Limpiar</b-button
                    >
                    <br />
                  </div>
                  <br />
                  <br />

              </div>

              <div class="col-md-6" v-if="idDenticion == 2">
                <md-toolbar class="subtitulos">
                  <h3>Periodontitis</h3> </md-toolbar
                ><br />
<!--                <div
                  class="row"
                  v-for="data of arrayPeriodontitis"
                  v-bind:key="data.id"
                >
                  <div class="col-5" align="left">{{ data }}.</div>
                  <div class="col-7" align="right">
                    <b-form-radio-group
                      :id="data.id"
                      v-model="data.value"
                      :options="data.elementos"
                      :name="'radio-options-apinamiento' + data.id"
                    ></b-form-radio-group>
                  </div>
                </div>-->

                <div
                    class="row"
                    v-for="data of padecimientosPeriodontitis"
                    v-bind:key="data.idPadecimiento"
                >
                  <div class="col-5" align="left">{{ data.nombre }}.</div>
                  <div class="col-7" align="right">
                    <b-form-radio-group
                        :id="data.idPadecimiento"
                        v-model="data.tiene"
                        :options="data.opciones"
                        :name="'radio-options-apinamiento' + data.idPadecimiento"
                    ></b-form-radio-group>
                  </div>
                </div>

                <div class="col-md-12">
                  <br />
                  <b-button
                    @click="
                      limpiarCamposExtrasPeriodontitis(
                        'periodontitis'
                      )
                    "
                    size="sm"
                    variant="outline-primary"
                    >Limpiar</b-button
                  ><br /><br />
                </div>
              </div>

            </div>

            <!-- ------------------------------ -->

            <!-- ------------------------------ -->
            <!-- ------------------------------ -->
            <!-- ------------------------------ -->
            <!-- ------------------------------ -->
            <!-- ------------------------------ -->
            <br /><br /><br />
            <div class="row" v-if="mostrarFormulario">
              <div class="col-md-12">
                <md-toolbar class="subtitulos">
                  <h3>Dentición {{ nombreDenticion }}</h3>
                </md-toolbar>
                <md-toolbar class="subtitulos">
                  <h5>
                    Favor de registrar en la primera fila el hallazgo clinico de
                    mayor relevancia
                  </h5>
                </md-toolbar>
                <br /><br /><br />
              </div>

              <div
                class="col-md-3"
                v-for="(data, key) of listaDientesPadecimiento"
                v-bind:key="key"
              >
                <b-card-group deck>
                  <b-card
                    :header="
                      'Hallazgos clinicos en OD.' +
                      data.numeroDiente +
                      ' ' +
                      data.nombreDiente 
                    "
                    header-tag="header"
                  >
                    <div v-for="(d, k) of data.padecimientos" v-bind:key="k">
                      <div v-if="idDenticion === 3">
                          <v-select
                              :options="
                            listaPadecimientosActivosPertenecientesADientes
                          "
                              v-model="d.idPadecimiento"
                              label="descripcion"
                              :reduce="(variable) => variable.idPadecimento"
                              @input="observarSiSeRequiereIngresarUnPadecimiento()"
                          >
                            <br />
                            <span slot="no-options">No hay coincidencias.</span>
                          </v-select>
                      </div>
                      <div v-else>
                        <v-select
                                  :options="
                            listaPadecimientosActivosPertenecientesADientes
                          "
                                  v-model="d.idPadecimiento"
                                  label="descripcion"
                                  :reduce="(variable) => variable.idPadecimento"
                        >
                          <br />
                          <span slot="no-options">No hay coincidencias.</span>
                        </v-select>
                      </div>

                      <br />
                    </div>
                    <br />

                    <br />
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="agregarFilaAlDiente(data)"
                    >
                      <b-icon icon="plus"></b-icon>
                      Agregar fila
                    </b-button>

                    <br />
                  </b-card>
                </b-card-group>
                <br /><br />
              </div>

              <br /><br />
            </div>

            <h3>
              <b-alert
                show
                variant="danger"
                v-if="
                  idSesionSeleccionada == null ||
                  idSesionSeleccionada == undefined ||
                  Number.isNaN(idSesionSeleccionada) ||
                  idSesionSeleccionada == 'null'
                "
              >
                El paciente NO cuenta con una sesión.</b-alert
              >
            </h3>
            <h3>
              <b-alert show variant="danger" v-if="mensajeMotivoCita != null">
                {{ mensajeMotivoCita }}</b-alert
              >
            </h3>
            <b-button
              variant="outline-primary"
              type="submit"
              v-if="mostrarFormulario"
              :disabled="loadingGuardar"
              >Guardar
              <b-spinner small v-if="loadingGuardar"></b-spinner>
            </b-button
            >
            <h3>
              <p v-if="ocultarBotonGuardado">
                El paciente ya cuenta con una solicitud de Hdx.
              </p>
            </h3>
          </b-form>
        </validation-observer>
      </b-tab>
      <b-tab
        title="Expediente digital"
        v-if="noTienePti && $localStorageService.can('Hdx_carga_01')"
      >
        <ExpedienteDigital :idPacienteExp="idPaciente"></ExpedienteDigital>
      </b-tab>
    </b-tabs>
  
    <div class="row"></div>

    <div class="row">
      <div class="col-12">
        <br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div>
  </div>
</template>

<script>
import RedireccionarAgenda from "../../components/RedireccionarAgenda.vue";
import ExpedienteDigital from "@/views/ExpedienteDigitalPaciente/ExpedienteDigital";
export default {
  name: "SolicitudPTI",
  components: {
    //    Header,
    RedireccionarAgenda,
    ExpedienteDigital,
  },

  props: {
    titulo: String,
    subtitulo: String,
    codigo: String,
    idPaciente: Number,
    idSesionSeleccionada: Number,
    doctores: Array,
    idDenticion: Number,
    esSdi: Boolean,
  },

  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      // variables basicas
      loadingGuardar: false,
      loading: false,
      loadingValidacionExistePTI: false,
      idEmpleado: null,
      idUsuario: null,
      existePtiMayorA6Meses: false,
      mostrarFormulario: false,
      noTienePti: false,

      //tags
      idTipoTag: null,
      bloquearformularioTag: false,
      tipoTagDatosArray: [],
      idTagMotivoCita: null,
      tagmotivocitaDatosArray: [],
      esCorrectoMotivoCita: true,

      seSeleccionoMotivoTagEnSesion: true,

      // Informacion basica
      tiempo: null,
      nombreClinica: null,
      idClinica: null,
      enfermedadSistemica: null,
      candidatoOrtodoncia: false,
      observaciones: null,

      pacienteTomaHerramientas: {
        mostrarTomaHerramientas: false,
        sesionTomaHerramientas: false,
        kitsInicio: [],
        idKit: undefined,
      },

      listaDiagnosticoExtras: [],
      arrayAdicional: [],
      arrayPeriodontitis: [],
      aplicaOrtodoncia: false,

      listaPeriodontitis: [],

      //filasss
      nombreDenticion: "",
      listaDientesPadecimiento: [],
      listaPadecimientosActivosPertenecientesADientes: [],
      seRequiereIngresarUnPadecimiento: true,

      //array a guardar
      datosDiagnosticoAGuardar: {
        idDenticion: null,
        idEmpleado: null,
        idUsuario: null,
        esSdi: false,
        idSesion: null,
        idTagMotivoCita: null,
        esCorrectoMotivoCita: true,
        idPaciente: null,
        idClinica: null,
        idCompania: 1,
        cuentaConHerramientas: false,
        enfermedadSistemica: null,
        candidatoOrtodoncia: null,
        observaciones: null,
        listaDientesPadecimiento: [],
        arrayExtras: [],
        tomaHerramienta: [],
        periodontitis: [],
        rutaExpediente: "",
      },
      rutaRadiografia: null,
      hoy: null,
      ocultarBotonGuardado: false,
      padecimientosPeriodontitis: [],

      descripcionTagMotivoCitaOriginal: null,
      mensajeMotivoCita: null,
    };
  },

  watch: {
    idTipoTag: function (idTipoTag) {
      this.tagmotivocitaDatosArray =
        this.tagmotivocitaDatosArrayOriginal.filter(
          (element) =>
            element.idTipoTag == idTipoTag &&
            element.idTagMotivoCita != 6 &&
            element.idTagMotivoCita != 13
        );
      if (!this.noEntrar) {
        this.idTagMotivoCita = this.tagmotivocitaDatosArray[0].idTagMotivoCita;
      } else {
        this.noEntrar = false;
      }
    },
    tagSeleccionadoEnLaCitaArray: function () {
      if (this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita == null) {
        this.esCorrectoMotivoCita = Boolean(false);
        this.seSeleccionoMotivoTagEnSesion = false;
      }
    },
    idTagMotivoCita: function (idTagMotivoCita) {
      if (idTagMotivoCita != undefined) {
        this.idTagMotivoCita = idTagMotivoCita;
      }
    },
  },
  methods: {
    obtenerUltimaSesionActivaConSinTomadeHerramientas() {
      if (
        this.idSesionSeleccionada == null ||
        this.idSesionSeleccionada == undefined ||
        Number.isNaN(this.idSesionSeleccionada) ||
        this.idSesionSeleccionada == "null"
      ) {
        const parametros = {idPaciente: this.id_Paciente, tomaHerramientas: this.esSdi}
        this.$http
          .post(
            this.$api +
              "sesion/obtenerultimasesionactivaconsintomadeherramientas", parametros)
          .then((response) => {
            this.idSesionSeleccionada = response.data.data.idSesion;
            if (this.idSesionSeleccionada == null) {
              this.mostrarFormulario = false;
            } else {
              setTimeout(() => this.tipoTag(), 2000);
            }
          });
      } else {
        this.tipoTag();
      }
    },
    existePti() {
      this.loadingValidacionExistePTI = true;
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(this.$api + "pti/existePtiMayor6Meses", parametros)
        .then((response) => {
          this.noTienePti = response.data.data;
          if (this.idSesionSeleccionada != null) {
            this.mostrarFormulario = response.data.data;
          }
        })
        .catch((error) => {
          console.error(
            "Error al obtener la validacion de existencia de un pti del  del paciente: " +
              error
          );
        })
        .finally(() => {
          this.loadingValidacionExistePTI = false;
          //   this.loadingPTI = false;
          this.pacienteNuevoTomaHerramientas();
        });
    },

    pacienteNuevoTomaHerramientas() {
      if (this.esSdi == true) {
        this.$http
          .get(
            this.$api +
              "sesion/pacienteNuevoTomaHerramientaSesionActivaPaciente?idPaciente=" +
              this.idPaciente +
              "&idSesion=" +
              this.idSesionSeleccionada
          )
          .then((response) => {
            this.pacienteTomaHerramientas = response.data.data;

            if (
              this.pacienteTomaHerramientas !== undefined &&
              this.pacienteTomaHerramientas.kitsInicio !== undefined &&
              this.pacienteTomaHerramientas.kitsInicio !== null
            ) {
              this.pacienteTomaHerramientas.idKit =
                this.pacienteTomaHerramientas.kitsInicio[0].idKit;
            }
          });
      }
    },

    async obtenerListaDientes() {
      //idDenticion -> 1	INFANTIL, 2	ADULTO, 3	MIXTO
      let url = "catalogos/listaDientes/ordenado";
      switch (this.idDenticion) {
        case 1:
          this.nombreDenticion = "INFANTIL";
          url = "catalogos/listaDientesInfantil";
          break;
        case 2:
          this.nombreDenticion = "ADULTO";
          url = "catalogos/listaDientesAdulto";
          break;
        case 3:
          this.nombreDenticion = "MIXTO";
          url = "catalogos/listaDientes/ordenados";
          break;
        default:
          this.nombreDenticion = "MIXTO";
          url = "catalogos/listaDientes/ordenados";
          break;
      }

      this.$http.get(this.$api + url).then(async (response) => {
        this.listaDientes = response.data.data;
        // this.dientesadulto = response.data.data;
        await this.generarrayDeDientesYFilaPadecimientos();
      });
    },

    async obtenerPadecimientosPeriodontitis() {
      let url = "diagnostico/hoja/listaPeriodontitis";

      this.$http.get(this.$api + url).then(async (response) => {
        this.padecimientosPeriodontitis = response.data.data;
      });
    },
    mostrarOcultarformularioTag(valorEsCorrectoMotivoCita) {
      if (
        this.idSesionSeleccionada == null ||
        this.idSesionSeleccionada == undefined ||
        Number.isNaN(this.idSesionSeleccionada)
      ) {
        setTimeout(() => {
          if (valorEsCorrectoMotivoCita === false) {
            this.bloquearformularioTag = true;
            this.tagSeleccionadoEnLaCita();
          } else if (valorEsCorrectoMotivoCita === true) {
            this.bloquearformularioTag = false;
          }
        }, 3000);
      } else {
        if (valorEsCorrectoMotivoCita === false) {
          this.bloquearformularioTag = true;
          this.tagSeleccionadoEnLaCita();
        } else if (valorEsCorrectoMotivoCita === true) {
          this.bloquearformularioTag = false;
        }
      }
    },
    tipoTag() {
      this.tipoTagDatosArray = [];

      this.$http
        .get(this.$api + "tagmotivocita/tipotag")
        .then((response) => {
          this.tipoTagDatosArray = response.data.data;
        })
        .finally(() => {
          this.tagMotivoCita();
        });
    },
    tagMotivoCita() {
      this.tagmotivocitaDatosArrayOriginal = [];

      const params = {
        idPaciente: this.idPaciente
      }
      this.$http.post( this.$api + "tagmotivocita/tagmotivocita/paciente", params )
        .then((response) => {
          this.tagmotivocitaDatosArrayOriginal = response.data.data;
        })
        .finally(() => {
          this.tagSeleccionadoEnLaCita();
        });
    },
    tagSeleccionadoEnLaCita() {
      this.tagSeleccionadoEnLaCitaArray = [];

      const params = {
        idSesion: this.idSesionSeleccionada
      }
      this.$http.post( this.$api +  "tagmotivocita/poridsesion", params )
        .then((response) => {
          this.tagSeleccionadoEnLaCitaArray = response.data.data;

          if (this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita != null) {
            this.idTagMotivoCita =
              this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita;
            this.esCorrectoMotivoCita = Boolean(true);
            this.seSeleccionoMotivoTagEnSesion = true;
            this.noEntrar = true;
            this.bloquearformularioTag = true;

            this.idTipoTag = this.tagSeleccionadoEnLaCitaArray.idTipoTag;

            //si es un motivo de dolor/urgencia no aplica hoja de diagnostico
            if (
              this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita == 6 ||
              this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita == 13
            ) {
              this.mostrarFormulario = false;
              this.mensajeMotivoCita =
                "No se puede generar un pti con un paciente de emergencia";
            }

            this.tagmotivocitaDatosArray =
              this.tagmotivocitaDatosArrayOriginal.filter(
                (element) => element.idTipoTag == this.idTipoTag
              );

            this.descripcionTagMotivoCitaOriginal =
              this.tagSeleccionadoEnLaCitaArray.descripcionTagMotivoCita;
            this.idTagMotivoCita =
              this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita;
          } else {
            this.esCorrectoMotivoCita = Boolean(false);
            this.seSeleccionoMotivoTagEnSesion = false;
            this.bloquearformularioTag = false;
          }
        });
    },
    listaDiagnosticoExtrasDefault(inicio) {
      // idDentincion -> 1	INFANTIL, 2	ADULTO, 3	MIXTO

      // idDentincion -> 1	INFANTIL, 2	ADULTO, 3	MIXTO
      this.listaDiagnosticoExtras = [
        {
          id: "padecimientocrecidesa",
          value: false,
          titulo: "Padecimientos de crecimiento y desarrollo",
          denticion: [
            {
              idDenticion: 1,
              seccion: "ortopedia",
            },
            {
              idDenticion: 3,
              seccion: "ortopedia",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Tiene",
              value: true,
            },
            {
              text: "No Tiene",
              value: false,
            },
          ],
        },
        {
          id: "bruxismo",
          value: false,
          titulo: "Bruxismo",
          denticion: [
            {
              idDenticion: 2,
              seccion: "adicional",
            },
            {
              idDenticion: 3,
              seccion: "adicional",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Tiene",
              value: true,
            },
            {
              text: "No Tiene",
              value: false,
            },
          ],
        },
        {
          id: "placasarro",
          value: false,
          titulo: "Placa/Sarro",
          denticion: [
            {
              idDenticion: 1,
              seccion: "adicional",
            },
            {
              idDenticion: 2,
              seccion: "adicional",
            },
            {
              idDenticion: 3,
              seccion: "adicional",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Tiene",
              value: true,
            },
            {
              text: "No Tiene",
              value: false,
            },
          ],
        },
        {
          id: "superior1", //IpbS1
          value: null,
          titulo: "Superior",
          denticion: [
            {
              idDenticion: 2,
              seccion: "periodontitis",
            },
            {
              idDenticion: 3,
              seccion: "periodontitis",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "I",
              value: 1,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
        {
          id: "superior2", //IpbS2
          value: null,
          titulo: "Superior",
          denticion: [
            {
              idDenticion: 2,
              seccion: "periodontitis",
            },
            {
              idDenticion: 3,
              seccion: "periodontitis",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "II",
              value: 1,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
        {
          id: "inferior3", //IpbI1
          value: null,
          titulo: "Inferior",
          denticion: [
            {
              idDenticion: 2,
              seccion: "periodontitis",
            },
            {
              idDenticion: 3,
              seccion: "periodontitis",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "III",
              value: 1,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
        {
          id: "inferior4", //IpbI2
          value: null,
          titulo: "Inferior",
          denticion: [
            {
              idDenticion: 2,
              seccion: "periodontitis",
            },
            {
              idDenticion: 3,
              seccion: "periodontitis",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "IV",
              value: 1,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
        {
          id: "escalones",
          value: null,
          titulo: "Escalones",
          denticion: [
            {
              idDenticion: 1,
              seccion: "ortopedia",
            },
            {
              idDenticion: 3,
              seccion: "ortopedia",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Mesial",
              value: 1,
            },
            {
              text: "Distal",
              value: 2,
            },
            {
              text: "Recto",
              value: 3,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
        {
          id: "mordidaprofunda",
          value: null,
          titulo: "Mordida Profunda",
          denticion: [
            {
              idDenticion: 1,
              seccion: "ortopedia",
            },
            {
              idDenticion: 3,
              seccion: "ortopedia",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Tiene",
              value: 1,
            },
            {
              text: "No Tiene",
              value: null,
            },
          ],
        },
        {
          id: "lineamedia",
          value: null,
          titulo: "Linea Media",
          denticion: [
            {
              idDenticion: 1,
              seccion: "ortopedia",
            },
            {
              idDenticion: 3,
              seccion: "ortopedia",
            },
          ],
          activo: false,
          elementos: [
            {
              text: "Desviada",
              value: 1,
            },
            {
              text: "Coincide",
              value: 2,
            },
            {
              text: "No Aplica",
              value: null,
            },
          ],
        },
      ];

      let denticion = this.idDenticion;

      if (inicio == true) {
        // Array adicional de acuardo al diente y el titulo
        this.arrayAdicional = this.listaDiagnosticoExtras.filter(function (
          elemento
        ) {
          let encontrado = elemento.denticion.filter(
            (dent) =>
              dent.idDenticion == denticion && dent.seccion == "adicional"
          );
          if (encontrado.length > 0) {
            return elemento;
          }
        });

        // Array periodontitis de acuardo al diente y el titulo
        this.arrayPeriodontitis = this.listaDiagnosticoExtras.filter(function (
          elemento
        ) {
          let encontrado = elemento.denticion.filter(
            (dent) =>
              dent.idDenticion == denticion && dent.seccion == "periodontitis"
          );
          if (encontrado.length > 0) {
            return elemento;
          }
        });
      }
    },
    limpiarCamposExtrasPeriodontitis(valor) {
      this.listaDiagnosticoExtrasDefault(false);
      let denticion = this.idDenticion;

      if (valor === "adicional") {
        this.arrayAdicional = null;
        // Array adicional de acuardo al diente y el titulo
        this.arrayAdicional = this.listaDiagnosticoExtras.filter(function (
          elemento
        ) {
          let encontrado = elemento.denticion.filter(
            (dent) =>
              dent.idDenticion == denticion && dent.seccion == "adicional"
          );
          if (encontrado.length > 0) {
            return elemento;
          }
        });
      }

      if (valor === "periodontitis") {
        this.padecimientosPeriodontitis.forEach(p => {
          p.tiene = false;
        })
      }
    },
    llenarListaPadecimientosActivosPertenecientesADientes() {
      var url = "catalogos/listaPadecimientosOd";
      this.$http.get(this.$api + url).then((response) => {
        this.listaPadecimientosActivosPertenecientesADientes =
          response.data.data;
      });
    },
    async generarrayDeDientesYFilaPadecimientos() {
      this.listaDientesPadecimiento = [];
      let i;

      for (i = 0; i < this.listaDientes.length; i++) {
        let diente = this.listaDientes[i].idDiente;
        let numeroDiente = this.listaDientes[i].numeroDiente;
        let nombre = this.listaDientes[i].nombre;
          this.listaDientesPadecimiento.push({
            idDiente: diente,
            numeroDiente: numeroDiente,
            nombreDiente: nombre,
            padecimientos: [
              {
                idPadecimiento: null,
              },
              {
                idPadecimiento: null,
              },
            ],
          });
      }
    },
    agregarFilaAlDiente(diente) {
      let indice = this.listaDientesPadecimiento.findIndex(
        (el) => el.idDiente == diente.idDiente
      );
      if (indice != -1) {
        this.listaDientesPadecimiento[indice].padecimientos.push({
          idPadecimiento: null,
        });
        this.observarSiSeRequiereIngresarUnPadecimiento();
      } else {
        alert("no existe el diente");
      }
    },
    async guardarFormulario() {
      this.loading = false;
      let boolean = false;
      this.listaDientesPadecimiento.forEach(l => {
        let result = l.padecimientos.some(k => k.idPadecimiento != null)
        if(result == true){
           boolean = true;
        }
      })

      if (!boolean) {
           this.$swal({
              position: "center",
              showConfirmButton: false,
              timer: 2500,
              toast: true,
              icon: "info",
              title: "Debe llenar al menos un padecimiento",
        })
        return false;
      }

      const rep = await this.vadicionActivarEceClinica();
      let blnTieneHdx = false;
      if (rep.data.data  && this.pacienteTomaHerramientas.idSesion > 0) {
        //si hoy subieron hdx
        const respuesta = await this.herramientasCompletas();
        if (respuesta.data.data) {
          blnTieneHdx = true;
        } else {
          this.loading = false;
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: "Debes realizar la toma de herramientas antes de guardar tu hdx",
          });
        }
      } else {
        blnTieneHdx = true;
      }
      if (blnTieneHdx) {
        let arrayExtras = [
          ...this.arrayAdicional,
          ...this.arrayPeriodontitis,
        ];

        this.datosDiagnosticoAGuardar = {
          idDenticion: this.idDenticion,
          idEmpleado: this.idEmpleado,
          idUsuario: this.idUsuario,
          esSdi: this.esSdi,
          idSesion: this.idSesionSeleccionada,
          idTagMotivoCita: this.idTagMotivoCita,
          esCorrectoMotivoCita: this.esCorrectoMotivoCita,
          idPaciente: this.idPaciente,
          idClinica: this.idClinica,
          idCompania: 1,
          cuentaConHerramientas: blnTieneHdx,
          enfermedadSistemica: this.enfermedadSistemica,
          candidatoOrtodoncia: this.candidatoOrtodoncia,
          observaciones: this.observaciones,
          listaDientesPadecimiento: this.listaDientesPadecimiento,
          arrayExtras: arrayExtras,
          tomaHerramienta: this.pacienteTomaHerramientas,
          periodontitis: this.padecimientosPeriodontitis,
          rutaExpediente: this.rutaRadiografia
        };

        //NO mostrar preguntas de toma de herramientas
        if (rep.data.data) {
          let url = this.$api + "diagnostico/hoja/guardarHojaDiagnostico";
          this.loadingGuardar = true;
          this.$http
            .post(url, this.datosDiagnosticoAGuardar)
            .then((response) => {
              if (response.status === 200) {
                this.mostrarFormulario = false;
                this.ocultarBotonGuardado = true;
                this.$swal({
                  icon: "success",
                  title: "Hoja de Diagnostico ingresada correctamente",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
                this.$forceUpdate();
              }
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: error.response.data.message,
              });
            })
            .finally(() => {
              this.loading = false;
              this.loadingGuardar = false;
            });
        } else {
          if (this.esSdi == false || (this.idDenticion == 1 || this.idDenticion == 3) ) {
            this.loadingGuardar = true;
            let url = this.$api + "diagnostico/hoja/guardarHojaDiagnostico";
            this.$http
              .post(url, this.datosDiagnosticoAGuardar)
              .then((response) => {
                if (response.status === 200) {
                  this.mostrarFormulario = false;
                  this.ocultarBotonGuardado = true;
                  this.$swal({
                    icon: "success",
                    title: "Hoja de Diagnostico ingresada correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                  });
                  this.$forceUpdate();
                }
              })
              .catch((error) => {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: error.response.data.message,
                });
              })
              .finally(() => {
                this.loading = false;
                this.loadingGuardar = true;
              });
          } else {
            this.$swal
              .fire({
                title:
                  "<strong>¿Tu paciente ya cuenta con Toma de Herramientas?</strong> <p></p>",

                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                allowOutsideClick: false,
              })
              .then(() => {
                this.$swal
                  .fire({
                    title:
                      "<strong>¿Tu paciente ya cuenta con Toma de Herramientas?</strong>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",

                    customClass: {
                      confirmButton: "btn-success",
                      cancelButton: "btn-danger",
                    },
                  })
                  .then((result) => {
                    var cuentaConHerramientas = false;

                    // result.isConfirmed
                    // result.isDismissed
                    if (result.isConfirmed) {
                      cuentaConHerramientas = true;
                    }

                    this.datosDiagnosticoAGuardar.cuentaConHerramientas =
                      cuentaConHerramientas;

                    if (!cuentaConHerramientas) {
                      this.$swal({
                        icon: "success",
                        title:
                          "La solicitud se guardara con estatus Sin Toma de Hdx  ",
                        showConfirmButton: false,
                        timer: 2500,
                      });
                    }

                    let url =
                      this.$api + "diagnostico/hoja/guardarHojaDiagnostico";
                    this.loadingGuardar = true;
                    this.$http
                      .post(url, this.datosDiagnosticoAGuardar)
                      .then((response) => {
                        if (response.status === 200) {
                          this.mostrarFormulario = false;
                          this.ocultarBotonGuardado = true;
                          this.$swal({
                            icon: "success",
                            title:
                              "Hoja de Diagnostico ingresada correctamente",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#0e6ba9",
                          });
                          this.$forceUpdate();
                        }
                      })
                      .catch((error) => {
                        this.$swal.fire({
                          icon: "error",
                          title: "Aviso",
                          text: error.response.data.message,
                        });
                      })
                      .finally(() => {
                        this.loading = false;
                        this.loadingGuardar = false;
                      });
                  });
              });
          }
        }
      } else {
        this.loadingGuardar = false;
      }
    },
    observarSiSeRequiereIngresarUnPadecimiento() {
      let entro = false;
      this.listaDientesPadecimiento.forEach((element) => {
        let i;
        for (i = 0; i < element.padecimientos.length; i++) {
          if (element.padecimientos[i].idPadecimiento != null) {
            this.seRequiereIngresarUnPadecimiento = false;
            entro = true;
          }
        }
      });

      if (entro == false) {
        this.seRequiereIngresarUnPadecimiento = true;
      }
    },

    allLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z \s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    obtenerRutaRadiografia() {
      const params = {
                idRutaPadre: 5
            }
      this.$http
        .post(this.$api + "rutaExpediente/listarRutasHijas", params)
        .then((response) => {
          for (let index = 0; index < response.data.data.length; index++) {
            if (response.data.data[index].idRuta === 6) {
              this.rutaRadiografia = response.data.data[index].path;
            }
          }
          this.rutaRadiografia = this.rutaRadiografia.replace(
            "#id_paciente",
            this.idPaciente
          );
        });
    },
    async vadicionActivaHerramientasHdx() {
      return await this.$http.get(
        this.$api + "rutaExpediente/validacionActivaHdx"
      );
    },
    async vadicionActivarEceClinica() {
      const parametros = {idClinica: this.idClinica}
      return await this.$http.post(
          this.$api + "catalogos/obtenerClinicasActivasECE", parametros
      );
    },
    async herramientasCompletas(){
      return await this.$http.get(
          this.$api + "rutaExpediente/validacionHerramientasCompletas?rutaDirectorio="+this.rutaRadiografia
          +"&idClinica="+this.idClinica
          +"&tipo="+1
      );
    }
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
    //tiene que ir primero para cargar la sesion

    this.obtenerUltimaSesionActivaConSinTomadeHerramientas();

    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.nombreClinica = this.$localStorageService.getNombreClinica();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    this.listaDiagnosticoExtrasDefault(true);
    this.obtenerListaDientes();
    this.llenarListaPadecimientosActivosPertenecientesADientes();
    this.hoy = this.$moment(new Date().format("YYYY-MM-DD"))._i;
    this.obtenerPadecimientosPeriodontitis();
  },
  mounted() {
    this.existePti();
    this.tiempo = new Date().toLocaleString();
    this.obtenerRutaRadiografia();
  },
};
</script>
